import { Component } from 'react';
import PropTypes from 'prop-types';

class AssumptionComponent extends Component {
  render() {
    const {
      keyValue,
      value,
    } = this.props;
    return (
      <div className="savings-container__assumption">
        <p title={keyValue}>{keyValue}</p>
        <h3 title={value}>{value}</h3>
      </div>
    );
  }
}

AssumptionComponent.propTypes = {
  keyValue: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

AssumptionComponent.defaultProps = {
  keyValue: '',
  value: '',
};

export default AssumptionComponent;
